import { useTranslation, Trans } from "react-i18next";
import hornIcon from "../../../static/assets/horn.svg";

const CampaignSuccessBanner = ({ improvementPercent }) => {
  const { t } = useTranslation();
  const hasPercent =
    improvementPercent != null && !Number.isNaN(Number(improvementPercent));
  const percent = hasPercent ? Math.round(Number(improvementPercent)) : null;

  return (
    <div className="campaign-success-banner" role="status">
      <img
        src={hornIcon}
        alt=""
        className="campaign-success-banner__icon"
        aria-hidden
      />
      <div className="campaign-success-banner__text">
        <p className="campaign-success-banner__title">
          {t("campaign.successTitle")}
        </p>
        <p className="campaign-success-banner__body">
          {hasPercent ? (
            <Trans
              i18nKey="campaign.successBody"
              values={{ percent }}
              components={{ bold: <strong />, br: <br /> }}
            />
          ) : (
            <Trans
              i18nKey="campaign.successBodyFallback"
              components={{ br: <br /> }}
            />
          )}
        </p>
      </div>
    </div>
  );
};

export default CampaignSuccessBanner;
